// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 9269 ? "0b7b90cd" : chunkId) + "." + {"2072":"ea76993046cab5eb","2811":"ba3bbf688a8bac45","9269":"9341876813340721","9560":"eada91313be8ebc6"}[chunkId] + ".js";
};